import React, { useEffect, useRef, useState } from "react";
import CurrencyConverter from "@heartinz/currency_subunit_converter";
import DateConverter from "@heartinz/date_and_time_processor";
import { CircularProgress } from "@mui/material";
import { useShowAlert } from "../../../../../context/AlertContext";
import autoTable from "jspdf-autotable";
import jsPDF from "jspdf";
import InterRegular from "../../../sale/font/Inter_24pt-Regular-normal";
import InterBold from "../../../sale/font/Inter_24pt-Bold-normal";
import { useNetwork } from "../../../../../context/NetworkContext";
import AxiosInstance from "../../../../../utils/AxiosInstance";
import uRLs from "../../../../../utils/baseUtils";
import handleError from "../../../../../constants/handleError";
import { useAuth } from "../../../../../context/AuthProvider";
import { usePermission } from "../../../../../context/PermissionContext";
import CashButton from "../../../sale/cashbtn";
import PayLaterButton from "../../../sale/PaylaterBtn";
import QRCode from "qrcode";
import {FormatedSaleData} from '../../../../../utils/print/GlobelSaleData';
import { DownloadIcon, PrinterIcon, ShowIcon } from "../../../../../constants/Icons";
const InvoiceThumnail5 = ({
  isViewData,
  selectedTheme,
  selectedSize,
  downloadbtn = false,
  payment = false,
}) => {
  const { checkNetwork } = useNetwork();
  const showAlert = useShowAlert();
  const { permission, blockedPermissions, storeSettings, viewOption } =
    usePermission();
  const { settings ,isUser} = useAuth();
  const [terms, setTerms] = useState([]);
  const [download, setDownload] = useState(false);
  const [print, setPrint] = useState(false);
  const [error, setErrors] = useState({});
   const [qrCodeDataUrl, setQrCodeDataUrl] = useState("");
  const [isPaySettleModalOpen, setIsPaySettleModalOpen] = useState(false);
  const [isMainModalOpen, setIsMainModalOpen] = useState(true);
  const [data, setData] = useState({});
  const cashRef = useRef();
  const paylaterRef = useRef();
 const globalData=FormatedSaleData(data);
  const formatTrackMode = (salemode) => {
    switch (salemode?.toUpperCase()) {
      case "BILL":
        return "BILL RECIEPT";
      case "INVOICE":
        return "TAX INVOICE";
      default:
        return salemode;
    }
  };
    const formatCurrencyINR = (value) => {    
    const formatted = Math.abs(value).toLocaleString('en-IN', {
    minimumFractionDigits: 0, 
    maximumFractionDigits: 2  
  });   
    return value < 0 ? `-₹${formatted}` : `₹${formatted}`;
  };

  const saleDate = data?.saledate;
  const timezone = data?.saleby?.timezone;

  let saleTime = "--:--";
  if (saleDate) {
    const zoned = DateConverter.convertToTimeZone(saleDate, timezone);
    saleTime = DateConverter.ISOToDisplayFormat(zoned);
  }

  let createdTime = "--:--";
  if (data?.createdAt) {
    const zoned = DateConverter.convertToTimeZone(data.createdAt, timezone);
    createdTime = DateConverter.ISOToDisplayFormat(zoned);
  }

  const handleSaleItems = async (saleId) => {
    try {
      if (!checkNetwork()) return;
      const response = await AxiosInstance.get(`module/sale/${saleId}`);
      return response.data.results;
    } catch (error) {
      handleError(error, showAlert);
      return null;
    }
  };

  const loadImageDimensions = (base64Src) => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = () =>
        resolve({ width: img.naturalWidth, height: img.naturalHeight });
      img.onerror = reject;
      img.src = base64Src;
    });
  };

  // new template starts ////// **/////////////////////////////

  const urlToBase64 = async (url) => {
    const res = await fetch(url);
    const blob = await res.blob();

    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  };

  const joinAddress = (...lines) =>
    lines
      .map((l) => l?.trim())
      .filter(Boolean)
      .join(", ");

  //commercial invoice

  const generateInvoice1 = async () => {
    const doc = new jsPDF("p", "mm", "a4");
    const pageW = doc.internal.pageSize.getWidth();
    const pageH = doc.internal.pageSize.getHeight();
    // Header Logic
    const MARGIN_LEFT = 10;
    const MARGIN_RIGHT = pageW - 10;
    const COL_RIGHT = pageW - 65;
    const COL_MIDDLE = pageW / 2.8;
    let y = 15;   
    const invoiceText =
      globalData?.status === "CANCELLED" ? "CANCELLED" : "TAX INVOICE";
    const originalText = "ORIGINAL FOR RECIPIENT";
    function drawSpacedText(doc, text, x, y, spacing = 0.8) {
      let cursorX = x;
      for (const ch of text) {
        doc.text(ch, cursorX, y);
        cursorX += doc.getTextWidth(ch) + spacing;
      }
    }
    // --- Row 1: Header Titles ---
    doc.setFont("Inter-Bold", "bold");
    doc.setFontSize(14);
    doc.setTextColor(20, 40, 100); // Navy blue for "TAX INVOICE"
    // doc.text(invoiceText, MARGIN_LEFT, y);
    drawSpacedText(doc, invoiceText, MARGIN_LEFT, y, 0.6);

    doc.setFontSize(8);
    doc.setTextColor(90, 90, 90); // Gray
    // doc.text(originalText, MARGIN_RIGHT, y, { align: "right" });
    const textWidth = originalText
      .split("")
      .reduce((w, ch) => w + doc.getTextWidth(ch) + 0.6, 0);

    drawSpacedText(doc, originalText, MARGIN_RIGHT - textWidth, y, 0.6);

    const address = joinAddress(
      globalData?.salefrom?.addressline1,
      globalData?.salefrom?.addressline2,
      globalData?.salefrom?.district,
      globalData?.salefrom?.state,
      globalData?.salefrom?.pincode
    );

    // --- Row 2: Seller Info & Logo ---
    y = 25;
    doc.setFontSize(13);
    doc.setTextColor(0);
    doc.text(globalData?.salefrom?.title || "", 10, y);

    // Placeholder for Logo (Replace with doc.addImage(base64, 'PNG', x, y, w, h))
    doc.setFontSize(22);
    doc.setTextColor(34, 139, 34); // DMart Green
    const imagePath = settings?.saleProfileData?.image
      ? uRLs?.IMAGE_URL + "profile/" + settings?.saleProfileData?.image
      : "/assets/images/logo-light.png";
    if (imagePath) {
      try {
        // const imagePath = settings?.saleProfileData?.image ? uRLs?.IMAGE_URL + "profile/" + settings?.saleProfileData?.image : "/assets/images/logo-light.png";
        const base64 = await urlToBase64(imagePath);
        const { width, height } = await loadImageDimensions(base64);

        const maxWidth = 40;
        const maxHeight = 10;

        let imgW = width;
        let imgH = height;

        const ratio = Math.min(maxWidth / imgW, maxHeight / imgH);

        const finalW = imgW * ratio;
        const finalH = imgH * ratio;

        const ext = imagePath.split(".").pop().toLowerCase();
        const format = ext === "png" ? "PNG" : "JPEG";
        const logoX = MARGIN_RIGHT - finalW;
        // Use finalW and finalH instead of maxWidth and maxHeight
        doc.addImage(base64, format, logoX, y, finalW, finalH);
        // doc.addImage(base64, format, pageW - 60, y - 5, maxWidth, maxHeight);
      } catch (err) {
        console.warn("Logo load failed:", err);
        // Fallback text if logo fails
        doc.setFontSize(22);
        doc.setTextColor(34, 139, 34);
        doc.text("Test-Store", MARGIN_RIGHT, y + 5, { align: "right" });
      }
    }

    doc.setFontSize(9);
    doc.setFont("Inter-Bold", "bold");
    doc.setTextColor(0);
    y += 6;
    doc.text(`GSTIN: ${globalData?.salefrom?.gstnumber || ""}`, MARGIN_LEFT, y);
    y += 4;
    doc.setFont("Inter-Regular", "normal");
    const addressWidth = pageW / 2 - MARGIN_LEFT - 5;
    const addressLines = doc.splitTextToSize(address, addressWidth);
    doc.text(addressLines, MARGIN_LEFT, y);
    y += addressLines.length * 4;

    doc.text(`Mobile: ${globalData?.salefrom?.phone || ""}`, MARGIN_LEFT, y);
    doc.setFont("Inter-Bold", "bold");
    // Check for PAN
    if (globalData?.salefrom?.pannumber) {
      y += 4;
      doc.text(`PAN: ${globalData?.salefrom.pannumber}`, MARGIN_LEFT, y);
    }

    // Check for FSSAI
    if (globalData?.salefrom?.fassi) {
      y += 4;
      doc.text(`FSSAI: ${globalData?.salefrom.fassi}`, MARGIN_LEFT, y);
    }

    // Check for CIN
    if (globalData?.salefrom?.cinnumber) {
      y += 4;
      doc.text(`CIN: ${globalData.salefrom.cinnumber}`, MARGIN_LEFT, y);
    }

    doc.setFont("Inter-Regular", "normal");
    // --- Row 3: Invoice Meta Data ---
    // y += 5;
    doc.setDrawColor(200);

    // doc.line(MARGIN_LEFT, y, MARGIN_RIGHT, y);// Thin separator line
    y += 5;
    const invDate = DateConverter.ISOToDisplayFormat(globalData?.saledate).date;

    y += 4;
    const startYAddress = y;

    doc.setFont("Inter-Bold", "bold");
    // doc.text(`Invoice #: ${ data.saleno || ''}`, 10, y);
    doc.setFontSize(9);
    doc.setFont("Inter-Bold", "bold");
    doc.text("Invoice #: ", 10, y);
    let invNoX = 10 + doc.getTextWidth("Invoice #: ");

    doc.setFontSize(10);
    doc.text(`${globalData?.saleno || ""}`, invNoX, y);

    // doc.text(`Invoice Date: ${invDate || ''}`, pageW / 2.8, y);
    doc.setFontSize(9);
    const dateLabel = "Invoice Date: ";
    const dateX = pageW / 2.8;
    doc.setFont("Inter-Bold", "bold");
    doc.text(dateLabel, dateX, y);
    let dateValX = dateX + doc.getTextWidth(dateLabel);
    doc.setFontSize(10);
    doc.text(`${invDate || ""}`, dateValX, y);

    doc.setFontSize(9);

    // doc.text(`Due Date: ${invDate || ''}`, pageW - 60, y);
    const rightX = pageW - 65;
    doc.setFont("Inter-Bold", "bold");
    doc.text("Invoice Time: ", rightX, y);
    let dueX = rightX + doc.getTextWidth("Invoice Time: ");
    doc.setFont("Inter-Regular", "normal");
    doc.setFontSize(10);
     const invDateTime = DateConverter.ISOToDisplayFormat(
                                              DateConverter.convertToTimeZone(
                                                globalData?.saledate,
                                                isUser.timezone,
                                              ),
                                            ).time
    doc.text(`${invDateTime || ""}`, dueX, y);
    const customerAddress = [
      [
        globalData?.saleto?.addressline1,
        globalData?.saleto?.addressline2,
        globalData?.saleto?.district,
        globalData?.saleto?.state,
        globalData?.saleto?.pincode,
      ]
        .filter(Boolean)
        .join(", "),

      // [data?.saleto?.district, data?.saleto?.state, data?.saleto?.pincode].filter(Boolean).join(", ")
    ].join("\n");
const shippingAddress = [
  [
    globalData?.saleto?.shippingAddress?.addressline1,
    globalData?.saleto?.shippingAddress?.addressline2,
    globalData?.saleto?.shippingAddress?.district,
    globalData?.saleto?.shippingAddress?.state,
    globalData?.saleto?.shippingAddress?.pincode,
  ]
    .filter(Boolean)
    .join(", "),
].join("\n");
const hasCustomer = !!globalData?.saleto;
const hasAddress = !!customerAddress;
const hasShipping = !!shippingAddress;
  const rowStartY = hasCustomer || hasAddress ? y + 5 : y;
    let maxColumnY = rowStartY;

    // Helper to draw Bold Label and Normal Value
    const drawLabelValue = (label, value, x, currentY) => {
      doc.setFont("Inter-Bold", "bold");
      doc.setTextColor(36, 36, 36);
      doc.text(`${label}: `, x, currentY);
      const labelWidth = doc.getTextWidth(`${label}: `);
      doc.setFont("Inter-Regular", "normal");
      doc.setTextColor(0);
      doc.text(String(value), x + labelWidth, currentY);
    };

    const colWidth = 55; // Same for Billing and Shipping
    const lineStep = 4; // Standard vertical spacing for lines
let col2X = pageW / 2.8;
let col3X = pageW - 65;
if (!hasCustomer) {
  col2X = MARGIN_LEFT;
  col3X = pageW / 2;
}

//  If only one column → full width feel
if (hasCustomer && !hasAddress) {
  col2X = pageW / 2;
}
  
    /* --- COLUMN 1: Customer Details --- */
    let col1Y = rowStartY;
    doc.setFontSize(9);
     if (hasCustomer) {
    doc.setFont("Inter-Regular", "normal");
    doc.text("Customer Details:", 10, col1Y);
    col1Y += 5;

    doc.setFont("Inter-Bold", "bold");
    const customerName = globalData?.saleto?.name || "-";
    const nameLines = doc.splitTextToSize(customerName, colWidth);
    doc.text(nameLines, 10, col1Y);
    col1Y += nameLines.length * lineStep;

    doc.setFont("Inter-Regular", "normal");
    doc.text(`Ph: ${globalData?.saleto?.phone || ""}`, 10, col1Y);

    if (globalData?.saleto?.gstnumber) {
      col1Y += 4;
      drawLabelValue("GSTIN", globalData.saleto.gstnumber, 10, col1Y);
    }
    if (globalData?.saleto?.fassi) {
      col1Y += 4;
      drawLabelValue("FSSAI", globalData.saleto.fassi, 10, col1Y);
    }
    if (globalData?.saleto?.pannumber) {
      col1Y += 4;
      drawLabelValue("PAN", globalData.saleto.pannumber, 10, col1Y);
    }
    if (globalData?.saleto?.cinnumber) {
      col1Y += 4;
      drawLabelValue("CIN", globalData.saleto.cinnumber, 10, col1Y);
    }
  }

    /* --- COLUMN 2: Billing Address --- */
    let col2Y = rowStartY;
    if (hasAddress) {
    doc.setFont("Inter-Regular", "normal");
    doc.text("Billing address:", col2X, col2Y);
    col2Y += 5;

    const billLines = doc.splitTextToSize(customerAddress || "-", colWidth);
    doc.text(billLines, col2X, col2Y);
    col2Y += billLines.length * lineStep; // Actual dynamic height
    }
    /* --- COLUMN 3: Shipping Address --- */
    let col3Y = rowStartY;
     if (hasShipping) { // Slightly adjusted for margin
    doc.setFont("Inter-Regular", "normal");
    doc.text("Shipping address:", col3X, col3Y);
    col3Y += 5;

    const shipLines = doc.splitTextToSize(shippingAddress  || "-", colWidth);
    doc.text(shipLines, col3X, col3Y);
    col3Y += shipLines.length * lineStep; // Actual dynamic height
     }
    // --- THE FIX: Find the absolute lowest point of all 3 columns ---
       maxColumnY = Math.max(
  hasCustomer ? col1Y : rowStartY,
  hasAddress ? col2Y : rowStartY,
  hasAddress ? col3Y : rowStartY
);

    /* --- PLACE OF SUPPLY --- */
    y = maxColumnY + 6;
    doc.setFontSize(10);
    doc.setFont("Inter-Regular", "normal");
    doc.text("Place Of Supply: ", 10, y);
    const supplyWidth = doc.getTextWidth("Place Of Supply: ");
    doc.setFont("Inter-Bold", "bold");
    doc.setTextColor(36, 36, 36);
    doc.text(globalData?.placeofsupply || "Tamil Nadu", 10 + supplyWidth, y);

    // Final safety margin before table
    y += 4;

    const leftBoxX = 8;

    /* -------------------------------------------------
     PRODUCT TABLE
  ------------------------------------------------- */
    autoTable(doc, {
      startY: y,
      theme: "plain",
      margin: { left: MARGIN_LEFT, right: MARGIN_LEFT }, // Balanced margins for symmetry
      // tableWidth: 'auto',
      styles: {
        font: "Inter-Regular",
        fontSize: 9,
        cellPadding: 2, // Extra vertical padding for clarity
        valign: "middle",
        lineHeight: 1.5,
        lineColor: selectedTheme?.templateTheme?.borderColor,
        textColor: [0, 0, 0], // True black text
      },
      headStyles: {
        font: "Inter-Bold",
        fontSize: 9,
        // textColor: [0, 0, 0],
        // fillColor: false,
        fillColor: selectedTheme?.templateTheme?.primaryColor || [20, 40, 100], // Navy blue fill
        textColor: selectedTheme?.templateTheme?.foregroundColor || [0, 0, 0], // White text
        lineWidth: { top: 0.1, bottom: 0.1 },
       lineColor: selectedTheme?.templateTheme?.borderColor,
      },
      head: [["#", "Item", "MRP", "Selling Price", "Qty", "Amount"]],
      body: globalData?.saleitems.map((it, i) => {
        // Exact Item + HSN formatting like image_f6047a.png
        const itemDesc = it.hsnsac
          ? `${it.title}\n${it.imode === "SERVICE" ? "SAC" : "HSN"}: ${
              it.hsnsac
            }`
          : it.title;
        const amount = 
          it.lineGrandTotal ;
        const mrp = it.mrp ;
        const baseprice = 
          it.baseprice ;
        return [
          i + 1,
          itemDesc,
          `₹${mrp}`,
          `₹${baseprice}`,
          `${it.quantity} ${(() => {
            const unitCode = it?.isSecondaryUnit
              ? it?.unitConfig?.secondaryUnitCode
              : it?.unitConfig?.primaryUnitCode;
            return unitCode || "";
          })()}`, //Pcs
          `₹${amount}`,
        ];
      }),
      columnStyles: {
        0: { cellWidth: 10, halign: "center" }, // S.No
        1: { cellWidth: "auto", halign: "left" }, // Flexible Description
        2: { cellWidth: 35, halign: "right" }, // Right-aligned Price
        3: { cellWidth: 30, halign: "right" },
        4: { cellWidth: 20, halign: "right" }, // Right-aligned Price
        5: { cellWidth: 25, halign: "right" }, // Amount
      },
      didParseCell: function (data) {
        // Header alignment
        if (data.section === "head") {
          const colId = data.column.index;
          if (colId === 0) data.cell.styles.halign = "center";
          if (colId === 2 || colId === 3 || colId === 4 || colId === 5)
            data.cell.styles.halign = "right";
        }

        // Body row styling
        if (data.section === "body") {
          // Light gray divider lines
          data.cell.styles.lineWidth = { bottom: 0.5 };

          // // 🔥 Make Item column (1) bold
          // if (data.column.index === 1) {
          //   data.cell.styles.font = "Inter-Bold";
          //    data.cell.styles.fontStyle = 'bold';
          //       //  data.cell.styles.textColor = [36, 36, 36];
          //       data.cell.styles.textColor = [72, 72, 72];
          // }

          // // 🔥 Make MRP column (2) bold
          // if (data.column.index === 2) {
          //   data.cell.styles.font = "Inter-Bold";
          //    data.cell.styles.fontStyle = 'bold';
          //         data.cell.styles.textColor = [72, 72, 72];
          // }
        }
      },
    });

    y += 3;

 
    const paidamount = (globalData?.grandtotal || 0) - (globalData?.balanceDue || 0);
      
 
    /* -------------------------------------------------
   TOTALS & GST SECTION (Right Side)
------------------------------------------------- */
    y = doc.lastAutoTable.finalY + 5; // Start after the table

    // 1. Grand Total Row
    doc.setFont("Inter-Bold", "bold");
    doc.setFontSize(12);

    const totalTextX = 140;
    const totalValueX = 200; // This is your right-aligned anchor

    doc.text("Total", totalTextX, y);
    doc.text(`₹${globalData?.grandtotal ||0}`, MARGIN_RIGHT, y, {
      align: "right",
    });

    // FIX: The line must end exactly at 200 to match your text alignment
    y += 2;
      doc.setDrawColor(selectedTheme?.templateTheme?.borderColor);
    doc.setLineWidth(0.1);
    doc.line(totalTextX, y, MARGIN_RIGHT, y); // Line now matches text width perfectly
    // 2. Tax Breakdown
    y += 6;
    // doc.setFont("Inter-Regular", "normal");
    doc.setFont("Inter-Regular", "normal");
    doc.setFontSize(9);
    // doc.setTextColor(0);
  
    const summaryData = [
      ["Total Amount Before Tax", `₹${globalData?.totalbaseprice ||0}`],
      ["CGST ", `₹${globalData?.cgstamount ||0}`],
      ["SGST ", `₹${globalData?.sgstamount ||0}`],
    ];

    summaryData.forEach(([label, value]) => {
      doc.text(label, 140, y);
      doc.text(value, MARGIN_RIGHT, y, { align: "right" });
      y += 5;
    });
    doc.setTextColor(64, 64, 64);

    doc.setFont("Inter-Regular", "normal");
    doc.setFontSize(9);

    doc.text(`Total Items  : ${globalData?.totalItems || 0} `, 10, y);
    doc.setTextColor(0);
    const amountWords = globalData?.amountinwords || "";
    doc.text(`Total amount (in words): INR ${amountWords}`, MARGIN_RIGHT, y, {
      align: "right",
    });

    y += 2;
    doc.setDrawColor(selectedTheme?.templateTheme?.borderColor);
    doc.setLineWidth(0.5);
    doc.line(10, y, MARGIN_RIGHT, y);

    y += 5;

    doc.setTextColor(0);
    const footerStartY = y;
    doc.setFontSize(9);

    doc.setFont("Inter-Bold", "bold");
    doc.setTextColor(32, 32, 32);
    y = footerStartY;

    const payX = 140;
    const payments = [
      ["Amount Payable:", `₹${globalData?.balanceDue || 0}`],
      ["Amount Paid:",`${paidamount.toFixed(2)}`],
    ];

    payments.forEach(([label, value]) => {
     if(label ==="Amount Payable:"){
      doc.setFont("Inter-Bold", "bold");
      }else{
          doc.setFont("Inter-Regular", "normal");
      }
      doc.text(label, payX, y);
      doc.text(value, MARGIN_RIGHT, y, { align: "right" });
      y += 4;
    });

        doc.setFontSize(8);
    y += 2;
    doc.setFont("Inter-Bold", "bold");
     const drawPaymentLine = (amount, label, currentY) => {
    doc.setFont("Inter-Regular", "normal");
    const labelWidth = doc.getTextWidth(label);
    doc.text(label, MARGIN_RIGHT, currentY, { align: "right" });

    // 2. Set font to Bold to draw the amount just to the left of the label
    doc.setFont("Inter-Bold", "bold");
    doc.text(`₹${amount} `, MARGIN_RIGHT - labelWidth, currentY, { align: "right" });
      };
      if (globalData?.cashPaid > 0) {
          drawPaymentLine(globalData.cashPaid, "Paid via Cash", y);
      }

      if (globalData?.upiPaid > 0) {
          y += 4;
          drawPaymentLine(globalData.upiPaid, "Paid via UPI", y);
      }

      if (globalData?.cardPaid > 0) {
          y += 4;
          drawPaymentLine(globalData.cardPaid, "Paid via Card", y);
      }

      if (globalData?.onlinePaid > 0) {
          y += 4;
          drawPaymentLine(globalData.onlinePaid, "Paid Online", y);
      }

    y += 10;
    const footerBlockHeight = 25;
    const spaceRemaining = pageH - y;

    // If remaining space is less than the footer height, jump to a new page
    if (spaceRemaining < footerBlockHeight) {
      doc.addPage();
      y = 20;
    }
    const currentY = y;

    const paymentSettings = data?.settings;

     const upiId =  storeSettings?.paymentSettings?.upiId || "";
    const payeeName = storeSettings?.paymentSettings?.bankDetails?.beneficiaryName || "";
    const upiUrl = `upi://pay?pa=${upiId}&pn=${encodeURIComponent(
      payeeName
    )}&cu=INR`;
    const hasUpi = upiId && upiId.trim().length > 0;
    const bankX = hasUpi ? 45 : 10;
    console.log("bankX", bankX);
    doc.setFontSize(10);
    doc.setTextColor(56, 56, 56);
    doc.setFont("Inter-Bold", "bold");

    if (upiId && upiId.trim() !== "") {
      let footerY = y;
      doc.text("Pay using UPI:", MARGIN_LEFT - 2, footerY);
      const qrCodeDataUrl = await QRCode.toDataURL(upiUrl, {
        errorCorrectionLevel: "L",
        scale: 4,
        margin: 1,
      });
      const qrX = MARGIN_LEFT - 2;
      const qrY = footerY + 2;
      const qrSize = 25;
      doc.addImage(qrCodeDataUrl, "JPEG", qrX, qrY, qrSize, qrSize);
    }

    doc.setFontSize(10);
    doc.setTextColor(56, 56, 56);
    doc.setFont("Inter-Bold", "bold");
    let bankY = currentY + 5;
   if (storeSettings?.paymentSettings?.bankDetails) {
      doc.text("Bank Details:", bankX, currentY);

      const bankDetails = [
        ["Bank:", storeSettings?.paymentSettings?.bankDetails?.ifscbankName || ""],
        ["Account #:", storeSettings?.paymentSettings?.bankDetails?.accountNo || ""],
        ["IFSC:", storeSettings?.paymentSettings?.bankDetails?.ifsc || ""],
        ["Branch:", storeSettings?.paymentSettings?.bankDetails?.branch || ""],
      ];

      bankDetails.forEach(([label, value]) => {
        doc.setFont("Inter-Regular", "normal");
        doc.text(label, bankX, bankY);
        doc.setFont("Inter-Bold", "bold");
        doc.text(String(value), bankX + 20, bankY);
        bankY += 5;
      });
    }

    let sigY = currentY;
    const rightX1 = 202;

    doc.setFontSize(6);
    let actualImgH = 0;
    let signBlockY = sigY;
    if (storeSettings?.invoiceSettings?.signature) {
      try {
        const signimg =
          uRLs.IMAGE_URL + storeSettings.invoiceSettings.signature;
        const base64 = await urlToBase64(signimg);
        const { width, height } = await loadImageDimensions(base64);
        const maxWidth = 35;
        const maxHeight = 20;
        const ratio = Math.min(maxWidth / width, maxHeight / height);
        const imgW = width * ratio;
        const imgH = height * ratio;
        doc.addImage(
          base64,
          signimg.endsWith(".png") ? "PNG" : "JPEG",
          MARGIN_RIGHT - imgW + 3,
          signBlockY,
          imgW,
          imgH
        );
      } catch {
        console.warn("Signature load failed");
      }
    }
    // sigY += 25;
    const sigTextY = signBlockY + (actualImgH > 0 ? actualImgH + 2 : 10);
    doc.setFontSize(8);

    y = Math.max(bankY, sigY) + 5;
    y += 6;

    doc.setTextColor(0);

    doc.setFont("Inter-Regular", "normal");
    doc.text("Authorized Signatory" || "", MARGIN_RIGHT, signBlockY + 12, {
      align: "right",
    });
    // const rowBottomY = Math.max(bankY, currentY + 27, signBlockY + 10);
    doc.setFont("Inter-Regular", "normal");
    doc.setFontSize(9);
    //  y = rowBottomY +3 ;
    const rowBottomY = Math.max(bankY, currentY + 27, sigTextY);

    y = rowBottomY + 10; // Only a 4mm gap before Notes

    // REDUCED BUFFER: Only jump to new page if within 1.5cm of bottom
    if (y > pageH - 20) {
      doc.addPage();
      y = 20;
    }
     

    if (terms?.length > 0) {
      doc.setFont("Inter-Bold", "bold");
      doc.setFontSize(10);
      // doc.setTextColor(36, 36, 36);
      if (y > pageH - 25) {
        doc.addPage();
        y = 20; // Reset to top of new page
      }
      doc.setTextColor(72, 72, 72);
      doc.text("Terms & Conditions", leftBoxX, y);
      doc.setTextColor(0);

      doc.setFont("Inter-Regular", "normal");
      doc.setFontSize(8.5);

      // 1. Split text into lines
      const termLines = doc.splitTextToSize(terms, pageW - 20);

      // 2. Define your custom line height (distance between points)
      const customLineHeight = 5; // Increase this number to get more space between lines

      let currentTermY = y + 5; // Start position for the first line

      // 3. Loop through lines to draw them one by one with extra space
      termLines.forEach((line) => {
        // Check if we need a new page before drawing the line
        if (currentTermY > pageH - 20) {
          doc.addPage();
          currentTermY = 20; // Reset Y for the new page
        }

        doc.text(line, leftBoxX, currentTermY);
        currentTermY += customLineHeight; // This creates the height/distance you want
      });

      y = currentTermY + 5; // Update leftY for whatever comes next
    }

    // draw table ONLY if rows exist

    if (storeSettings?.negobillBranding) {
      const y = pageH - 5;
      const rightX = pageW / 2;

      // Text parts
      const normalText = "Powered by ";
      const boldText = "NegoBill.com";

      doc.setFontSize(8);

      // Measure widths
      doc.setFont("Inter-Regular", "normal");
      const normalW = doc.getTextWidth(normalText);

      doc.setFont("Inter-Bold", "bold");

      // Start X so whole string is right-aligned
      const startX = rightX;

      // Draw normal part
      doc.setFont("Inter-Regular", "normal");
      doc.text(normalText, startX - 10, y);

      // Draw bold part
      doc.setFont("Inter-Bold", "bold");
      doc.text(boldText, startX - 10 + normalW, y);
    }
    setDownload(false);
    return doc;
  };

  //A4 bill commercial

  const generateBill1 = async () => {
    const doc = new jsPDF("p", "mm", "a4");
    const pageW = doc.internal.pageSize.getWidth();
    const pageH = doc.internal.pageSize.getHeight();
    // Header Logic
    const MARGIN_LEFT = 10;
    const MARGIN_RIGHT = pageW - 10;
    const COL_RIGHT = pageW - 65;
    const COL_MIDDLE = pageW / 2.8;
    let y = 15;
      const formatCurrencyINR = (value) => {    
    const formatted = Math.abs(value).toLocaleString('en-IN', {
    minimumFractionDigits: 0, 
    maximumFractionDigits: 2  
  });   
    return value < 0 ? `-₹${formatted}` : `₹${formatted}`;
  };
    const invoiceText =
      globalData?.status === "CANCELLED" ? "CANCELLED" : "BILL RECIEP";
    const originalText = "ORIGINAL FOR RECIPIENT";
    function drawSpacedText(doc, text, x, y, spacing = 0.8) {
      let cursorX = x;
      for (const ch of text) {
        doc.text(ch, cursorX, y);
        cursorX += doc.getTextWidth(ch) + spacing;
      }
    }
    // --- Row 1: Header Titles ---
    doc.setFont("Inter-Bold", "bold");
    doc.setFontSize(14);
    doc.setTextColor(20, 40, 100); // Navy blue for "TAX INVOICE"
    // doc.text(invoiceText, MARGIN_LEFT, y);
    drawSpacedText(doc, invoiceText, MARGIN_LEFT, y, 0.6);

    doc.setFontSize(8);
    doc.setTextColor(90, 90, 90); // Gray
    // doc.text(originalText, MARGIN_RIGHT, y, { align: "right" });
    const textWidth = originalText
      .split("")
      .reduce((w, ch) => w + doc.getTextWidth(ch) + 0.6, 0);

    drawSpacedText(doc, originalText, MARGIN_RIGHT - textWidth, y, 0.6);

    const address = joinAddress(
      globalData?.salefrom?.addressline1,
      globalData?.salefrom?.addressline2,
      globalData?.salefrom?.district,
      globalData?.salefrom?.state,
      globalData?.salefrom?.pincode
    );

    // --- Row 2: Seller Info & Logo ---
    y = 25;
    doc.setFontSize(13);
    doc.setTextColor(0);
    doc.text(globalData?.salefrom?.title || "", 10, y);

    // Placeholder for Logo (Replace with doc.addImage(base64, 'PNG', x, y, w, h))
    doc.setFontSize(22);
    doc.setTextColor(34, 139, 34); // DMart Green
    const imagePath = settings?.saleProfileData?.image
      ? uRLs?.IMAGE_URL + "profile/" + settings?.saleProfileData?.image
      : "/assets/images/logo-light.png";
    if (imagePath) {
      try {
        // const imagePath = settings?.saleProfileData?.image ? uRLs?.IMAGE_URL + "profile/" + settings?.saleProfileData?.image : "/assets/images/logo-light.png";
        const base64 = await urlToBase64(imagePath);
        const { width, height } = await loadImageDimensions(base64);

        const maxWidth = 40;
        const maxHeight = 10;

        let imgW = width;
        let imgH = height;

        const ratio = Math.min(maxWidth / imgW, maxHeight / imgH);

        const finalW = imgW * ratio;
        const finalH = imgH * ratio;

        const ext = imagePath.split(".").pop().toLowerCase();
        const format = ext === "png" ? "PNG" : "JPEG";
        const logoX = MARGIN_RIGHT - finalW;
        // Use finalW and finalH instead of maxWidth and maxHeight
        doc.addImage(base64, format, logoX, y, finalW, finalH);
        // doc.addImage(base64, format, pageW - 60, y - 5, maxWidth, maxHeight);
      } catch (err) {
        console.warn("Logo load failed:", err);
        // Fallback text if logo fails
        doc.setFontSize(22);
        doc.setTextColor(34, 139, 34);
        doc.text("Test-Store", MARGIN_RIGHT, y + 5, { align: "right" });
      }
    }

    doc.setFontSize(9);
    doc.setFont("Inter-Bold", "bold");
    doc.setTextColor(0);
    y += 6;
    doc.text(`GSTIN: ${globalData?.salefrom?.gstnumber || ""}`, MARGIN_LEFT, y);
    y += 4;
    doc.setFont("Inter-Regular", "normal");
    const addressWidth = pageW / 2 - MARGIN_LEFT - 5;
    const addressLines = doc.splitTextToSize(address, addressWidth);
    doc.text(addressLines, MARGIN_LEFT, y);
    y += addressLines.length * 4;

    doc.text(`Mobile: ${globalData?.salefrom?.phone || ""}`, MARGIN_LEFT, y);
    doc.setFont("Inter-Bold", "bold");
    // Check for PAN
    if (data?.salefrom?.pannumber) {
      y += 4;
      doc.text(`PAN: ${globalData.salefrom.pannumber}`, MARGIN_LEFT, y);
    }

    // Check for FSSAI
    if (globalData?.salefrom?.fassi) {
      y += 4;
      doc.text(`FSSAI: ${globalData.salefrom.fassi}`, MARGIN_LEFT, y);
    }

    // Check for CIN
    if (globalData?.salefrom?.cinnumber) {
      y += 4;
      doc.text(`CIN: ${globalData.salefrom.cinnumber}`, MARGIN_LEFT, y);
    }

    doc.setFont("Inter-Regular", "normal");
    // --- Row 3: Invoice Meta Data ---
    // y += 5;
    doc.setDrawColor(200);

    // doc.line(MARGIN_LEFT, y, MARGIN_RIGHT, y);// Thin separator line
    y += 5;
    const invDate = DateConverter.ISOToDisplayFormat(globalData?.saledate).date;

    y += 4;
    const startYAddress = y;

    doc.setFont("Inter-Bold", "bold");
    // doc.text(`Invoice #: ${ data.saleno || ''}`, 10, y);
    doc.setFontSize(9);
    doc.setFont("Inter-Bold", "bold");
    doc.text("Bill #: ", 10, y);
    let invNoX = 10 + doc.getTextWidth("Bill #: ");

    doc.setFontSize(10);
    doc.text(`${globalData?.saleno || ""}`, invNoX, y);

    // doc.text(`Invoice Date: ${invDate || ''}`, pageW / 2.8, y);
    doc.setFontSize(9);
    const dateLabel = "Bill Date: ";
    const dateX = pageW / 2.8;
    doc.setFont("Inter-Bold", "bold");
    doc.text(dateLabel, dateX, y);
    let dateValX = dateX + doc.getTextWidth(dateLabel);
    doc.setFontSize(10);
    doc.text(`${invDate || ""}`, dateValX, y);

    doc.setFontSize(9);

    // doc.text(`Due Date: ${invDate || ''}`, pageW - 60, y);
    const rightX = pageW - 60;
    doc.setFont("Inter-Bold", "bold");
    doc.text("Due Date: ", rightX, y);
    let dueX = rightX + doc.getTextWidth("Due Date: ");
    doc.setFont("Inter-Regular", "normal");
    doc.setFontSize(10);
    doc.text(`${invDate || ""}`, dueX, y);
    const customerAddress = [
      [
        globalData?.saleto?.addressline1,
        globalData?.saleto?.addressline2,
        globalData?.saleto?.district,
        globalData?.saleto?.state,
        globalData?.saleto?.pincode,
      ]
        .filter(Boolean)
        .join(", "),

      // [data?.saleto?.district, data?.saleto?.state, data?.saleto?.pincode].filter(Boolean).join(", ")
    ].join("\n");

    const rowStartY = y + 5;
    let maxColumnY = rowStartY;

    // Helper to draw Bold Label and Normal Value
    const drawLabelValue = (label, value, x, currentY) => {
      doc.setFont("Inter-Bold", "bold");
      doc.setTextColor(36, 36, 36);
      doc.text(`${label}: `, x, currentY);
      const labelWidth = doc.getTextWidth(`${label}: `);
      doc.setFont("Inter-Regular", "normal");
      doc.setTextColor(0);
      doc.text(String(value), x + labelWidth, currentY);
    };

    const colWidth = 55; // Same for Billing and Shipping
    const lineStep = 4; // Standard vertical spacing for lines

    /* --- COLUMN 1: Customer Details --- */
    let col1Y = rowStartY;
    doc.setFontSize(9);
    doc.setFont("Inter-Regular", "normal");
    doc.text("Customer Details:", 10, col1Y);
    col1Y += 5;

    doc.setFont("Inter-Bold", "bold");
    const customerName = globalData?.saleto?.name || "-";
    const nameLines = doc.splitTextToSize(customerName, colWidth);
    doc.text(nameLines, 10, col1Y);
    col1Y += nameLines.length * lineStep;

    doc.setFont("Inter-Regular", "normal");
    doc.text(`Ph: ${globalData?.saleto?.phone || ""}`, 10, col1Y);

    if (globalData?.saleto?.gstnumber) {
      col1Y += 4;
      drawLabelValue("GSTIN", globalData.saleto.gstnumber, 10, col1Y);
    }
    if (globalData?.saleto?.fassi) {
      col1Y += 4;
      drawLabelValue("FSSAI", globalData.saleto.fassi, 10, col1Y);
    }
    if (globalData?.saleto?.pannumber) {
      col1Y += 4;
      drawLabelValue("PAN", globalData.saleto.pannumber, 10, col1Y);
    }
    if (globalData?.saleto?.cinnumber) {
      col1Y += 4;
      drawLabelValue("CIN", globalData.saleto.cinnumber, 10, col1Y);
    }

    /* --- COLUMN 2: Billing Address --- */
    let col2Y = rowStartY;
    const col2X = pageW / 2.8;
    doc.setFont("Inter-Regular", "normal");
    doc.text("Billing address:", col2X, col2Y);
    col2Y += 5;

    const billLines = doc.splitTextToSize(customerAddress || "-", colWidth);
    doc.text(billLines, col2X, col2Y);
    col2Y += billLines.length * lineStep; // Actual dynamic height

    /* --- COLUMN 3: Shipping Address --- */
    let col3Y = rowStartY;
    const col3X = pageW - 65; // Slightly adjusted for margin
    doc.setFont("Inter-Regular", "normal");
    doc.text("Shipping address:", col3X, col3Y);
    col3Y += 5;

    const shipLines = doc.splitTextToSize(customerAddress || "-", colWidth);
    doc.text(shipLines, col3X, col3Y);
    col3Y += shipLines.length * lineStep; // Actual dynamic height

    // --- THE FIX: Find the absolute lowest point of all 3 columns ---
    maxColumnY = Math.max(col1Y, col2Y, col3Y);

    /* --- PLACE OF SUPPLY --- */
    y = maxColumnY + 6;
    doc.setFontSize(10);
    doc.setFont("Inter-Regular", "normal");
    doc.text("Place Of Supply: ", 10, y);
    const supplyWidth = doc.getTextWidth("Place Of Supply: ");
    doc.setFont("Inter-Bold", "bold");
    doc.setTextColor(36, 36, 36);
    doc.text(globalData?.placeofsupply || "Tamil Nadu", 10 + supplyWidth, y);

    // Final safety margin before table
    y += 4;

    const leftBoxX = 8;

    /* -------------------------------------------------
     PRODUCT TABLE
  ------------------------------------------------- */
    autoTable(doc, {
      startY: y,
      theme: "plain",
      margin: { left: MARGIN_LEFT, right: MARGIN_LEFT }, // Balanced margins for symmetry
      // tableWidth: 'auto',
      styles: {
        font: "Inter-Regular",
        fontSize: 9,
        cellPadding: 2, // Extra vertical padding for clarity
        valign: "middle",
        lineHeight: 1.5,
        textColor: [0, 0, 0], // True black text
      },
      headStyles: {
        font: "Inter-Bold",
        fontSize: 9,
        textColor: [0, 0, 0],
        fillColor: false,
        // fillColor: selectedTheme?.templateTheme?.primaryColor || [20, 40, 100], // Navy blue fill
        // textColor: selectedTheme?.templateTheme?.foregroundColor || [0, 0, 0], // White text
        lineWidth: { top: 0.5, bottom: 0.5 },
        lineColor: [0, 0, 0],
      },
      head: [["#", "Item", "MRP", "Selling Price", "Qty", "Amount"]],
      body: globalData?.saleitems.map((it, i) => {
        // Exact Item + HSN formatting like image_f6047a.png
        const itemDesc = it.hsnsac
          ? `${it.title}\n${it.imode === "SERVICE" ? "SAC" : "HSN"}: ${
              it.hsnsac
            }`
          : it.title;
        const amount = CurrencyConverter.toCurrency(
          it.lineGrandTotal || 0,
          "INR"
        );
        const mrp = CurrencyConverter.toCurrency(it.mrp || 0, "INR");
        const baseprice = CurrencyConverter.toCurrency(
          it.baseprice || 0,
          "INR"
        );
        return [
          i + 1,
          itemDesc,
          `₹${formatCurrencyINR(mrp)}`,
          `₹${formatCurrencyINR(baseprice)}`,
          `${it.quantity} `, //Pcs
          `₹${formatCurrencyINR(amount)}`,
        ];
      }),
      columnStyles: {
        0: { cellWidth: 10, halign: "center" }, // S.No
        1: { cellWidth: "auto", halign: "left" }, // Flexible Description
        2: { cellWidth: 35, halign: "right" }, // Right-aligned Price
        3: { cellWidth: 30, halign: "right" },
        4: { cellWidth: 20, halign: "right" }, // Right-aligned Price
        5: { cellWidth: 25, halign: "right" }, // Amount
      },
      didParseCell: function (data) {
        // Header alignment
        if (data.section === "head") {
          const colId = data.column.index;
          if (colId === 0) data.cell.styles.halign = "center";
          if (colId === 2 || colId === 3 || colId === 4 || colId === 5)
            data.cell.styles.halign = "right";
        }

        // Body row styling
        if (data.section === "body") {
          // Light gray divider lines
          data.cell.styles.lineWidth = { bottom: 0.5 };

          // // 🔥 Make Item column (1) bold
          // if (data.column.index === 1) {
          //   data.cell.styles.font = "Inter-Bold";
          //    data.cell.styles.fontStyle = 'bold';
          //       //  data.cell.styles.textColor = [36, 36, 36];
          //       data.cell.styles.textColor = [72, 72, 72];
          // }

          // // 🔥 Make MRP column (2) bold
          // if (data.column.index === 2) {
          //   data.cell.styles.font = "Inter-Bold";
          //    data.cell.styles.fontStyle = 'bold';
          //         data.cell.styles.textColor = [72, 72, 72];
          // }
        }
      },
    });

    y += 3;


    const grantotal = globalData?.grandtotal || 0;
    const paidamount = (globalData?.grandtotal || 0) - (globalData?.balanceDue || 0);
      

    /* -------------------------------------------------
   TOTALS & GST SECTION (Right Side)
------------------------------------------------- */
    y = doc.lastAutoTable.finalY + 5; // Start after the table

    // 1. Grand Total Row
    doc.setFont("Inter-Bold", "bold");
    doc.setFontSize(12);

    const totalTextX = 140;
    const totalValueX = 200; // This is your right-aligned anchor

    doc.text("Total", totalTextX, y);
    doc.text(`₹${formatCurrencyINR(grantotal || "")}`, MARGIN_RIGHT, y, {
      align: "right",
    });

    // FIX: The line must end exactly at 200 to match your text alignment
    y += 2;
    doc.setLineWidth(0.1);
    doc.line(totalTextX, y, MARGIN_RIGHT, y); // Line now matches text width perfectly
    // 2. Tax Breakdown
    y += 6;
    // doc.setFont("Inter-Regular", "normal");
    doc.setFont("Inter-Bold", "bold");
    doc.setFontSize(9);
    // doc.setTextColor(0);
    doc.setTextColor(48, 48, 48); // #303030
    doc.setTextColor(64, 64, 64);

    doc.setFont("Inter-Regular", "normal");
    doc.setFontSize(9);

    doc.text(`Total Items  : ${globalData?.totalItems || 0} `, 10, y);
    doc.setTextColor(0);
    const amountWords = globalData?.amountinwords || "";
    doc.text(`Total amount (in words): INR ${amountWords}`, MARGIN_RIGHT, y, {
      align: "right",
    });

    y += 2;
    doc.setDrawColor(0, 0, 0);
    doc.setLineWidth(0.5);
    doc.line(10, y, MARGIN_RIGHT, y);

    y += 5;

    doc.setTextColor(0);
    const footerStartY = y;
    doc.setFontSize(9);

    doc.setFont("Inter-Bold", "bold");
    doc.setTextColor(32, 32, 32);
    y = footerStartY;
    const balanceDue = grantotal - paidamount;
    const payX = 140;
    const payments = [
      ["Amount Payable:", `₹${formatCurrencyINR(balanceDue || "")}`],
      ["Amount Paid:", `₹${formatCurrencyINR(paidamount || "")}`],
    ];

    payments.forEach(([label, value]) => {
      doc.setFont("Inter-Bold", "bold");
      doc.text(label, payX, y);
      doc.text(value, MARGIN_RIGHT, y, { align: "right" });
      y += 4;
    });

   

    doc.setFontSize(8);
    y += 2;
    doc.setFont("Inter-Bold", "bold");
    if (globalData?.cashPaid > 0) {
      const cashText = `₹${globalData?.cashPaid} Paid via Cash on ${invDate}`;
      doc.text(cashText, MARGIN_RIGHT, y, { align: "right" });
    }

    if (globalData?.upiPaid > 0) {
      y += 4;
      const upiText = `₹${globalData?.upiPaid||0} Paid via UPI on ${invDate}`;
      doc.text(upiText, MARGIN_RIGHT, y, { align: "right" });
    }

    if (globalData?.cardPaid > 0) {
      y += 4;
      const cardText = `₹${globalData?.cardPaid||0} Paid via Card on ${invDate}`;
      doc.text(cardText, MARGIN_RIGHT, y, { align: "right" });
    }

    if (globalData?.onlinePaid > 0) {
      y += 4;
      const onlineText = `₹${globalData?.onlinePaid ||0} Paid Online on ${invDate}`;
      doc.text(onlineText, MARGIN_RIGHT, y, { align: "right" });
    }

    y += 10;
    const footerBlockHeight = 25;
    const spaceRemaining = pageH - y;

    // If remaining space is less than the footer height, jump to a new page
    if (spaceRemaining < footerBlockHeight) {
      doc.addPage();
      y = 20;
    }
    const currentY = y;


     const upiId =  storeSettings?.paymentSettings?.upiId || "";
    const payeeName = storeSettings?.paymentSettings?.bankDetails?.beneficiaryName || "";

    const upiUrl = `upi://pay?pa=${upiId}&pn=${encodeURIComponent(
      payeeName
    )}&cu=INR`;
    const hasUpi = upiId && upiId.trim().length > 0;
    const bankX = hasUpi ? 45 : 10;
    console.log("bankX", bankX);
    doc.setFontSize(10);
    doc.setTextColor(56, 56, 56);
    doc.setFont("Inter-Bold", "bold");

    if (upiId && upiId.trim() !== "") {
      let footerY = y;
      doc.text("Pay using UPI:", MARGIN_LEFT - 2, footerY);
      const qrCodeDataUrl = await QRCode.toDataURL(upiUrl, {
        errorCorrectionLevel: "L",
        scale: 4,
        margin: 1,
      });
      const qrX = MARGIN_LEFT - 2;
      const qrY = footerY + 2;
      const qrSize = 25;
      doc.addImage(qrCodeDataUrl, "JPEG", qrX, qrY, qrSize, qrSize);
    }

    doc.setFontSize(10);
    doc.setTextColor(56, 56, 56);
    doc.setFont("Inter-Bold", "bold");
    let bankY = currentY + 5;
     if (storeSettings?.paymentSettings?.bankDetails) {
      doc.text("Bank Details:", bankX, currentY);

      const bankDetails = [
        ["Bank:", storeSettings?.paymentSettings?.bankDetails?.ifscbankName || ""],
        ["Account #:", storeSettings?.paymentSettings?.bankDetails?.accountNo || ""],
        ["IFSC:", storeSettings?.paymentSettings?.bankDetails?.ifsc || ""],
        ["Branch:", storeSettings?.paymentSettings?.bankDetails?.branch || ""],
      ];

      bankDetails.forEach(([label, value]) => {
        doc.setFont("Inter-Regular", "normal");
        doc.text(label, bankX, bankY);
        doc.setFont("Inter-Bold", "bold");
        doc.text(String(value), bankX + 20, bankY);
        bankY += 5;
      });
    }

    let sigY = currentY;
    const rightX1 = 202;

    doc.setFontSize(6);
    let actualImgH = 0;
    let signBlockY = sigY;
    if (storeSettings?.invoiceSettings?.signature) {
      try {
        const signimg =
          uRLs.IMAGE_URL + storeSettings.invoiceSettings.signature;
        const base64 = await urlToBase64(signimg);
        const { width, height } = await loadImageDimensions(base64);
        const maxWidth = 35;
        const maxHeight = 20;
        const ratio = Math.min(maxWidth / width, maxHeight / height);
        const imgW = width * ratio;
        const imgH = height * ratio;
        doc.addImage(
          base64,
          signimg.endsWith(".png") ? "PNG" : "JPEG",
          MARGIN_RIGHT - imgW + 3,
          signBlockY,
          imgW,
          imgH
        );
      } catch {
        console.warn("Signature load failed");
      }
    }
    // sigY += 25;
    const sigTextY = signBlockY + (actualImgH > 0 ? actualImgH + 2 : 10);
    doc.setFontSize(8);

    y = Math.max(bankY, sigY) + 5;
    y += 6;

    doc.setTextColor(0);

    doc.setFont("Inter-Regular", "normal");
    doc.text("Authorized Signatory" || "", MARGIN_RIGHT, signBlockY + 14, {
      align: "right",
    });
    // const rowBottomY = Math.max(bankY, currentY + 27, signBlockY + 10);
    doc.setFont("Inter-Regular", "normal");
    doc.setFontSize(9);
    //  y = rowBottomY +3 ;
    const rowBottomY = Math.max(bankY, currentY + 27, sigTextY);

    y = rowBottomY + 10; // Only a 4mm gap before Notes

    // REDUCED BUFFER: Only jump to new page if within 1.5cm of bottom
    if (y > pageH - 20) {
      doc.addPage();
      y = 20;
    }
    doc.setFont("Inter-Bold", "bold");
    doc.setFontSize(10);
    doc.setTextColor(72, 72, 72);
    doc.text("Notes:", 8, y);

    y += 5;

    doc.setFont("Inter-Regular", "normal");
    doc.setFontSize(9);
    doc.setTextColor(0);

    doc.text("Thank you for the Business:", 8, y);
    y += 10;

    if (terms?.length > 0) {
      doc.setFont("Inter-Bold", "bold");
      doc.setFontSize(10);
      // doc.setTextColor(36, 36, 36);
      if (y > pageH - 25) {
        doc.addPage();
        y = 20; // Reset to top of new page
      }
      doc.setTextColor(72, 72, 72);
      doc.text("Terms & Conditions", leftBoxX, y);
      doc.setTextColor(0);

      doc.setFont("Inter-Regular", "normal");
      doc.setFontSize(8.5);

      // 1. Split text into lines
      const termLines = doc.splitTextToSize(terms, pageW - 20);

      // 2. Define your custom line height (distance between points)
      const customLineHeight = 5; // Increase this number to get more space between lines

      let currentTermY = y + 5; // Start position for the first line

      // 3. Loop through lines to draw them one by one with extra space
      termLines.forEach((line) => {
        // Check if we need a new page before drawing the line
        if (currentTermY > pageH - 20) {
          doc.addPage();
          currentTermY = 20; // Reset Y for the new page
        }

        doc.text(line, leftBoxX, currentTermY);
        currentTermY += customLineHeight; // This creates the height/distance you want
      });

      y = currentTermY + 5; // Update leftY for whatever comes next
    }

    // draw table ONLY if rows exist

    if (storeSettings?.negobillBranding) {
      const y = pageH - 5;
      const rightX = pageW / 2;

      // Text parts
      const normalText = "Powered by ";
      const boldText = "NegoBill.com";

      doc.setFontSize(8);

      // Measure widths
      doc.setFont("Inter-Regular", "normal");
      const normalW = doc.getTextWidth(normalText);

      doc.setFont("Inter-Bold", "bold");

      // Start X so whole string is right-aligned
      const startX = rightX;

      // Draw normal part
      doc.setFont("Inter-Regular", "normal");
      doc.text(normalText, startX - 10, y);

      // Draw bold part
      doc.setFont("Inter-Bold", "bold");
      doc.text(boldText, startX - 10 + normalW, y);
    }
    setDownload(false);
    return doc;
  };

  const handleDownload = async (data) => {
    setDownload(true);
    const { salemode, saleno } = data || {};

    let doc;

    if (salemode?.toUpperCase() === "BILL") {
      doc = await generateBill1();
    } else {
      doc = await generateInvoice1();
    }

    const filenamePrefix = formatTrackMode(salemode)?.replace(/\s+/g, "_");
    doc.save(`${filenamePrefix}_${saleno}.pdf`);
  };

  const handlePrint = async (data, overrideSize = null) => {
    setPrint(true);
    try {
      if (!checkNetwork()) return;

      const paperSize = overrideSize || selectedSize;
      const upperMode = data?.salemode?.toUpperCase();
      let doc;

      if (paperSize === "BILL") {
        doc = await generateBill1();
      } else {
        doc = await generateInvoice1();
      }

      const blob = doc.output("blob");
      const blobUrl = URL.createObjectURL(blob);

      const iframe = document.createElement("iframe");
      iframe.style.position = "fixed";
      iframe.style.right = "0";
      iframe.style.bottom = "0";
      iframe.style.width = "0";
      iframe.style.height = "0";
      iframe.style.border = "none";
      iframe.src = blobUrl;
      document.body.appendChild(iframe);

      iframe.onload = () => {
        const printWindow = iframe.contentWindow;

        const cleanup = () => {
          // Remove iframe safely
          if (iframe && iframe.parentNode) {
            iframe.parentNode.removeChild(iframe);
          }

          // Remove listeners
          window.removeEventListener("afterprint", cleanup);
          printWindow.matchMedia("(print)").removeListener(handlePrintState);
        };

        const handlePrintState = (mql) => {
          // WHEN PRINT PREVIEW CLOSES (printed OR canceled)
          if (!mql.matches) {
            setTimeout(cleanup, 50); // small delay makes Chrome stable
          }
        };

        // Watch print state
        printWindow.matchMedia("(print)").addListener(handlePrintState);

        // Also catch Chrome's afterprint
        window.addEventListener("afterprint", cleanup);
        setPrint(false);
        setTimeout(() => {
          if (window.bootstrap && window.bootstrap.Dropdown) {
            const dropdownElementList = [].slice.call(
              document.querySelectorAll(".dropdown-toggle")
            );
            dropdownElementList.map(function (dropdownToggleEl) {
              return new window.bootstrap.Dropdown(dropdownToggleEl);
            });
          }
        }, 100);
        // Trigger printing
        setTimeout(() => {
          printWindow.focus();
          printWindow.print();
        }, 300);
      };
    } catch (error) {
      setPrint(false);
      handleError(error, showAlert);
      return false;
    }
    // finally {
    //   setPrint(false);
    // }
  };

  useEffect(() => {
    setData(isViewData);
  }, [isViewData]);

  useEffect(() => {
    jsPDF.API.events.push([
      "addFonts",
      function () {
        this.addFileToVFS("Inter_24pt-Regular-normal.ttf", InterRegular);
        this.addFileToVFS("Inter_24pt-Bold-normal.ttf", InterBold);
        this.addFont(
          "Inter_24pt-Regular-normal.ttf",
          "Inter-Regular",
          "normal"
        );
        this.addFont("Inter_24pt-Bold-normal.ttf", "Inter-Bold", "bold");
      },
    ]);
  }, []);

 
   const formatCurrency2 = (value) => {
     const amount = CurrencyConverter.toCurrency(value, "INR");
     const formatted = Math.abs(amount).toLocaleString('en-IN', {
     minimumFractionDigits: 0, // Don't force .00
     maximumFractionDigits: 2  // Show up to 2 decimals if they exist (like .78)
   }); 
   
     return value < 0 ? `-₹${formatted}` : `₹${formatted}`;
   };

  useEffect(() => {
    const handleKeyDown = (event) => {
      if ((event.ctrlKey || event.metaKey) && event.key.toLowerCase() === "p") {
        event.preventDefault();
        handlePrint(data);
      }
    };
    const handleAfterPrint = () => {
      setTimeout(() => {
        window.focus();
      }, 100);
    };

    window.addEventListener("keydown", handleKeyDown);
    window.addEventListener("afterprint", handleAfterPrint);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
      window.removeEventListener("afterprint", handleAfterPrint);
    };
  }, [data]);

  useEffect(() => {
    setTerms(storeSettings?.invoiceSettings?.termsAndConditions);
  }, [storeSettings?.invoiceSettings]);
   useEffect(() => {
          const upi = storeSettings?.paymentSettings?.upiId;
      
          const name = storeSettings?.paymentSettings?.bankDetails?.beneficiaryName;
          if (!upi) return; // skip until upi is available
      
          const upiUrl = `upi://pay?pa=${upi}&pn=${encodeURIComponent(name)}&cu=INR`;
          console.log("ip",upiUrl)
          QRCode.toDataURL(upiUrl)
            .then((url) => {
              setQrCodeDataUrl(url);
            })
            .catch((err) => {
              console.error("QR Code generation failed: ", err);
            });
        }, [storeSettings?.paymentSettings?.upiId, storeSettings?.paymentSettings?.bankDetails?.beneficiaryName]);
        
  return (
    <>
      <div className="invoice-scale">
        {globalData?.salemode === "INVOICE" ? (
          <div className="tm_container">
            <div className="tm_invoice_wrap">
              <div className="tm_invoice tm_style1 tm_type1">
                <div className="tm_invoice_in">
                  <div className="d-flex justify-content-between mb-3">
                    <div
                      className="tm_text_uppercase"
                      style={{ fontSize: "18px", fontWeight: "600" }}
                    >
                      {globalData?.salemode && formatTrackMode(globalData?.salemode)}
                    </div>
                    <div>ORIGINAL FOR RECIPIENT</div>
                  </div>
                  <div className="row">
                    <div className="col-7 pe-1 ">
                      <div className="d-flex gap-2 align-items-start">
                        {/* <div className="tm_logo">
                                      {data?.salefrom?.image && (
                                        <img
                                          src={
                                            uRLs.IMAGE_URL +
                                            "profile/" +
                                            data?.salefrom?.image
                                          }
                                          className="img-rounded logo mb-0"
                                          height="45"
                                          width="150"
                                          style={{ objectFit: "contain" }}
                                        />
                                      )}
                                    </div> */}
                        <div>
                          <div
                            style={{
                              fontSize: "17px",
                              fontWeight: "600",
                              marginBottom: "5px",
                            }}
                          >
                            {globalData?.salefrom?.title || ""}
                          </div>
                          {globalData?.salefrom?.gstnumber && (
                            <div
                              style={{
                                fontSize: "12px",
                                fontWeight: "600",
                                marginBottom: "0px",
                              }}
                            >
                              <>GSTIN:</> {globalData?.salefrom?.gstnumber || ""}
                            </div>
                          )}
                          <div>
                            {globalData?.salefrom?.addressline1 || ""}{" "}
                            {globalData?.salefrom?.addressline2 || ""}{" "}
                          </div>
                          <div>
                            {globalData?.salefrom?.district || ""}
                            {", "}
                            {globalData?.salefrom?.state || ""}
                            {", "}
                            {globalData?.salefrom?.pincode || ""}
                          </div>
                          {/* <div>
                                        CIN :{globalData?.salefrom?.cinnumber}
                                      </div> */}
                          {/* {globalData?.salefrom?.pannumber && (
                                        <div>
                                          <strong>PAN:</strong>{" "}
                                          {globalData?.salefrom?.pannumber || ""}
                                        </div>
                                      )} */}
                          <div> Mobile: {globalData?.salefrom?.phone || ""}</div>
                          {/* {globalData?.salefrom?.gstnumber && (
                                        <div>
                                          <strong>GSTIN:</strong>{" "}
                                          {globalData?.salefrom?.gstnumber || ""}
                                        </div>
                                      )} */}
                        </div>
                      </div>
                    </div>
                    <div className="col-5 ps-1 ">
                      <div className="tm_logo text-end">
                        {("/assets/images/logo-light.png" ||
                          settings?.saleProfileData?.image) && (
                          <img
                            src={
                              settings?.saleProfileData?.image
                                ? uRLs.IMAGE_URL +
                                  "profile/" +
                                  settings?.saleProfileData?.image
                                : "/assets/images/logo-light.png"
                            }
                            className="img-rounded logo mb-0"
                            height="45"
                            width="150"
                            style={{ objectFit: "contain" }}
                          />
                        )}
                      </div>
                      {/* <div className="border h-100 p-2">
                                  <div className="tm_text_uppercase text-end">
                                    {data.salemode &&
                                      formatTrackMode(data.salemode)}
                                  </div>
                                  <div>
                                    <b>Invoice #</b> : {data.saleno}
                                  </div>
                                  <div>
                                    <b>Date</b> : {saleTime.date}
                                  </div>
                                  <div>
                                    <b>Place Of Supply</b> :{" "}
                                    {data?.salefrom?.state || ""}
                                  </div>
                                  <div>
                                    <b>Due Date</b> : {saleTime.date}
                                  </div>
                                  <div>
                                    <b>Sales Person</b> : -
                                  </div>
                                </div> */}
                    </div>
                  </div>
                  <div className="row mt-3">
                    <div className="col-4 pe-1">
                      <div>
                        <div
                          style={{
                            marginBottom: "4px",
                          }}
                        >
                          <span style={{ fontWeight: "600" }}>Invoice #:</span>
                          {""}
                          <strong className="font-14">{globalData?.saleno}</strong>
                        </div>
                        <div
                          style={{
                            fontSize: "12px",
                            // fontWeight: "600",
                            marginBottom: "5px",
                          }}
                        >
                          Customer Details
                        </div>
                        <div
                          style={{
                            fontSize: "12px",
                            marginBottom: "0px",
                          }}
                        >
                          {globalData?.saleto?.name || ""}
                        </div>
                      
                                   
                        <div> ph: {globalData?.saleto?.phone || ""}</div>
                        {/* <div> Email {data.saleto?.email || ""}</div> */}
                        {globalData?.saleto?.gstnumber && (
                          <div>
                            <strong>GSTIN:</strong>{" "}
                            {globalData?.saleto?.gstnumber || ""}
                          </div>
                        )}
                        {globalData?.saleto?.pannumber && (
                          <div>
                            <strong>PAN:</strong> {globalData?.saleto?.pannumber || ""}
                          </div>
                        )}
                        {globalData?.saleto?.cinnumber && (
                          <div>
                            <strong>CIN :</strong>
                            {globalData?.saleto?.cinnumber || ""}
                          </div>
                        )}
                        <div className="my-2 font-14">
                          Place Of Supply :
                          <strong>{globalData?.saleto?.state || ""} </strong>
                        </div>
                      </div>
                    </div>
                    <div className="col-4 ps-1">
                      <div>
                        <div
                          style={{
                            marginBottom: "4px",
                          }}
                        >
                          <span style={{ fontWeight: "600" }}>
                            Invoice Date :
                          </span>
                          {""}
                          <strong className="font-14">{saleTime.date}</strong>
                        </div>
                        <div
                          style={{
                            fontSize: "12px",
                            // fontWeight: "600",
                            marginBottom: "5px",
                          }}
                        >
                          Billing Address
                        </div>
                        {/* <div
                                      style={{
                                        fontSize: "12px",
                                        marginBottom: "0px",
                                      }}
                                    >
                                      {data.saleto?.name || ""}
                                    </div> */}
                        <div>
                          {globalData?.saleto?.addressline1 || ""}{" "}
                          {globalData?.saleto?.addressline2 || ""}{" "}
                        </div>
                        <div>
                          {globalData?.saleto?.state || ""}{" "}
                          {globalData?.saleto?.district || ""}{" "}
                          {globalData?.saleto?.country || ""} -{" "}
                          {globalData?.saleto?.pincode || ""}
                        </div>
                      
                      </div>
                    </div>
                    <div className="col-4 ps-1">
                      <div>
                        <div
                          style={{
                            marginBottom: "4px",
                          }}
                        >
                          <span style={{ fontWeight: "600" }}>Invoice Time:</span>
                          {""}
                          <strong className="font-14">{DateConverter.ISOToDisplayFormat(
                                                                    DateConverter.convertToTimeZone(
                                                                      globalData?.saledate,
                                                                      isUser.timezone,
                                                                    ),
                                                                  ).time}</strong>
                        </div>
                        {globalData.saleto?.shippingAddress &&
                           (globalData.saleto?.shippingAddress?.addressline1 ||
                            globalData.saleto?.shippingAddress?.addressline2 ) && (
                       <> <div
                          style={{
                            fontSize: "12px",
                            // fontWeight: "600",
                            marginBottom: "5px",
                          }}
                        >
                          Shipping Address
                        </div>                    
                        <div>
                          {globalData?.saleto?.shippingAddress?.addressline1 || ""}{" "}
                          {globalData?.saleto?.shippingAddress?.addressline2 || ""}{" "}
                        </div>
                        <div>
                          {globalData?.saleto?.shippingAddress?.state || ""}{" "}
                          {globalData?.saleto?.shippingAddress?.district || ""}{" "}
                          {globalData?.saleto?.shippingAddress?.country || ""} -{" "}
                          {globalData?.saleto?.shippingAddress?.pincode || ""}
                        </div>
                           </> )}
                      </div>
                    </div>
                  </div>

                  <table
                    // className="items"
                    width="100%"
                    style={{
                      marginTop: "6px",
                      borderCollapse: "collapse",
                      borderTop: `1px solid ${selectedTheme?.templateTheme?.borderColor} `,
                      // borderBottom: "1px solid #000"
                    }}
                    cellPadding="4"
                  >
                    <thead>
                      <tr
                        style={{
                          borderTop: `1px solid ${selectedTheme?.templateTheme?.borderColor} `,
                          borderBottom: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                        }}
                      >
                        <th
                          className="force-style"
                          style={{
                            width: "20px",
                            textAlign: "center",
                            "--th-color":
                              selectedTheme?.templateTheme?.foregroundColor,
                            "--th-bg":
                              selectedTheme?.templateTheme?.primaryColor,
                            // "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                          }}
                        >
                          #
                        </th>
                        <th
                          className="force-style"
                          style={{
                            // width: "240px",
                            textAlign: "left",
                            "--th-bg":
                              selectedTheme?.templateTheme?.primaryColor,
                            "--th-color":
                              selectedTheme?.templateTheme?.foregroundColor,
                            // "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                          }}
                        >
                          Item
                        </th>
                        {/* <th
                                    className="force-style"
                                    style={{
                                      width: "120px",
                                      textAlign: "center",
                                      "--th-bg":
                                        selectedTheme?.templateTheme
                                          ?.primaryColor,
                                      "--th-color":
                                        selectedTheme?.templateTheme
                                          ?.foregroundColor,
                                      "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                    }}
                                  >
                                    HSN/SAC
                                  </th> */}
                        <th
                          className="force-style"
                          style={{
                            width: "50px",
                            textAlign: "right",
                            "--th-bg":
                              selectedTheme?.templateTheme?.primaryColor,
                            "--th-color":
                              selectedTheme?.templateTheme?.foregroundColor,
                            // "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                          }}
                        >
                          MRP
                        </th>
                        <th
                          className="force-style"
                          style={{
                            width: "100px",
                            textAlign: "right",
                            "--th-bg":
                              selectedTheme?.templateTheme?.primaryColor,
                            "--th-color":
                              selectedTheme?.templateTheme?.foregroundColor,
                            //     ?.foregroundColor,
                            // "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                          }}
                        >
                          Selling Price
                        </th>
                        <th
                          className="force-style"
                          style={{
                            width: "100px",
                            textAlign: "right",
                            "--th-bg":
                              selectedTheme?.templateTheme?.primaryColor,
                            "--th-color":
                              selectedTheme?.templateTheme?.foregroundColor,
                            // "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                          }}
                        >
                          Qty
                        </th>

                        <th
                          className="force-style"
                          style={{
                            width: "100px",
                            textAlign: "right",
                            "--th-bg":
                              selectedTheme?.templateTheme?.primaryColor,
                            "--th-color":
                              selectedTheme?.templateTheme?.foregroundColor,
                            // "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                          }}
                        >
                          Amount
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {globalData?.saleitems?.map((product, index) => (
                        <tr
                          key={index}
                          style={{
                            borderTop: `1px solid ${selectedTheme?.templateTheme?.borderColor} `,
                            borderBottom: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                          }}
                        >
                          <td
                            className="force-style"
                            style={{
                              textAlign: "center",
                              fontSize: "12px",
                              // "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                            }}
                          >
                            {index + 1}
                          </td>
                          <td
                            className="force-style"
                            style={{
                              textAlign: "left",
                              fontSize: "12px",
                              width: "53%",
                              // "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                            }}
                          >
                            <div>{product.title}</div>
                            {/* {product.imode === "SERVICE" && (
                                      <div className="ms-0 fsz-10 lh-13 mb-1">
                                        {product.description}
                                      </div>
                                    )} */}
                            {/* {product.imode === "PRODUCT" &&
                                        product.note && (
                                          <div className="ms-0 fsz-10 mb-1">
                                            {product?.note}
                                          </div>
                                        )} */}
                            {product.hsnsac && (
                              <div>
                                <span className="fw-medium">
                                  {" "}
                                  {product.imode === "SERVICE"
                                    ? "SAC:"
                                    : "HSN:"}
                                </span>{" "}
                                {product.hsnsac}
                              </div>
                            )}
                            {/* {product.discount > 0 && (
                                      <>
                                        <div>
                                          <span className="fw-medium">MRP : </span> ₹
                                          {CurrencyConverter.toCurrency(
                                            product.mrp || 0,
                                            "INR"
                                          )}
                                        </div>
                                        <div>
                                          <span className="fw-medium">Discount : </span> -
                                          ₹
                                          {CurrencyConverter.toCurrency(
                                            product.discount || 0,
                                            "INR"
                                          )}
                                        </div>
                                      </>
                                    )} */}
                          </td>
                          {/* <td
                                      className="force-style"
                                      style={{
                                        textAlign: "center",
                                        fontSize: "12px",
                                        "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                      }}
                                    >
                                      {product.hsnsac}
                                    </td> */}
                          <td
                            className="force-style"
                            style={{
                              textAlign: "right",
                              fontSize: "12px",
                              // "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                            }}
                          >
                           {formatCurrencyINR(CurrencyConverter.toCurrency(
                              product?.mrp || 0,
                              "INR"
                            ))}
                          </td>
                          <td
                            className="force-style"
                            style={{
                              textAlign: "right",
                              fontSize: "12px",
                              // "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                            }}
                          >
                            {formatCurrencyINR(CurrencyConverter.toCurrency(
                              product?.baseprice || 0,
                              "INR"
                            ))}
                          </td>
                          <td
                            className="force-style"
                            style={{
                              textAlign: "right",
                              fontSize: "12px",
                              // "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                            }}
                          >
                            {product?.quantity} {(() => {
                                const unitCode = product?.isSecondaryUnit
                                  ? product?.unitConfig?.secondaryUnitCode
                                  : product?.unitConfig?.primaryUnitCode;
                                return unitCode || "";
                              })()}
                          </td>
                          {/* <td
                                      className="force-style"
                                      style={{
                                        textAlign: "center",
                                        fontSize: "12px",
                                        "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                      }}
                                    >
                                      {CurrencyConverter.toCurrency(
                                        product?.lineTotalBasePrice || 0,
                                        "INR",
                                      )}
                                    </td>
                                    <td
                                      className="force-style"
                                      style={{
                                        textAlign: "center",
                                        fontSize: "12px",
                                        "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                      }}
                                    >
                                      {`${product?.taxpercentage}%`}
                                    </td>
                                    <td
                                      className="force-style"
                                      style={{
                                        textAlign: "center",
                                        fontSize: "12px",
                                        "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                      }}
                                    >
                                      ₹
                                      {CurrencyConverter.toCurrency(
                                        product?.lineTotalTaxAmount || 0,
                                        "INR",
                                      )}
                                    </td> */}
                          <td
                            className="force-style"
                            style={{
                              textAlign: "right",
                              fontSize: "12px",
                              // "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                            }}
                          >
                           {formatCurrencyINR(CurrencyConverter.toCurrency(
                              product.lineGrandTotal || 0,
                              "INR"
                           ) )}
                          </td>
                        </tr>
                      ))}
                      <tr>
                        <td colSpan="3"></td>
                        <td
                          colSpan="2"
                          style={{
                            borderBottom: `1px solid ${selectedTheme?.templateTheme?.borderColor} `,
                          }}
                        >
                          <div
                            style={{
                              fontSize: "15px",
                              fontWeight: 600,
                              textAlign: "start",
                            }}
                          >
                            Total
                          </div>
                        </td>
                        <td
                          style={{
                            textAlign: "end",
                            fontSize: "14px",
                            fontWeight: 600,
                            borderBottom: `1px solid ${selectedTheme?.templateTheme?.borderColor} `,
                          }}
                        >
                         ₹{globalData?.grandtotal}
                        </td>
                      </tr>
                      <tr>
                        <td colSpan="3"></td>
                        <td colSpan="2" className="text-end">
                          Total Amount Before Tax{" "}
                        </td>
                        <td className="text-end font-12 fw-600"
                         
                        >
                         ₹{globalData?.totalbaseprice}
                         
                        </td>
                      </tr>
                      {globalData?.salefrom?.statecode &&
                      globalData?.saleto?.statecode &&
                      globalData?.salefrom?.statecode !== globalData?.saleto?.statecode ? (
                        <tr>
                          <td colSpan="3"></td>
                          <td colSpan="2" className="text-end">
                            IGST
                          </td>
                          <td
                           className="text-end font-12 fw-600"
                          >
                           ₹{globalData?.igstamount || 0}
                          </td>
                        </tr>
                      ) : (
                        <>
                          <tr>
                            <td colSpan="3"></td>
                            <td colSpan="2" className="text-end">
                              CGST
                            </td>
                            <td
                            className="text-end font-12 fw-600"
                            >
                              ₹{globalData?.cgstamount || 0}
                            </td>
                          </tr>
                          <tr>
                            <td colSpan="2"></td>
                            <td colSpan="3" className="text-end">
                              SGST
                            </td>
                            <td
                           className="text-end font-12 fw-600"
                            >
                             ₹{globalData?.sgstamount || 0}
                            </td>
                          </tr>
                        </>
                      )}
                      <tr
                        style={{
                          borderBottom: `1px solid ${selectedTheme?.templateTheme?.borderColor} `,
                        }}
                      >
                        <td colSpan={2} style={{ width: "30%" }}>
                          Total Items : {globalData?.saleitems?.length}
                        </td>

                        <td
                          colSpan={4}
                          className=" text-end font-12 fw-500 mb-0"
                         
                        >
                          Total Amount (in Words){globalData?.amountinwords}
                        </td>
                      </tr>
                      <tr>
                        <td colSpan="3"></td>
                        <td colSpan="2" className="text-end">
                          Amount Payable
                        </td>
                        <td
                        className="text-end font-12 fw-600 mb-0"                         
                        >
                        ₹{globalData?.balanceDue || 0}
                        </td>
                      </tr>
                      <tr>
                        <td colSpan="3"></td>
                        <td colSpan="2" className="text-end">
                          Amount Paid
                        </td>
                        <td
                        className="text-end font-12 fw-600"                         
                        >
                          ₹{globalData?.grandtotal || 0}
                        </td>
                      </tr>
                     {globalData?.cashPaid > 0 && (
                        <tr>
                          <td colSpan="2"></td>
                          <td
                            colSpan={4}
                            className="text-end font-12  mb-0 pb-0"
                          >
                             <span><b>₹{globalData.cashPaid}</b> Paid via Cash</span>
                          </td>
                        </tr>
                      )}
                    {globalData?.upiPaid > 0 && (
                        <tr>
                          <td colSpan="2"></td>
                          <td
                            colSpan={4}
                          className="text-end font-12  mb-0 pb-0"
                          >
                           <span><b>₹{globalData.upiPaid}</b> Paid via UPI</span>
                          </td>
                        </tr>
                      )}
                        {globalData?.cardPaid > 0 && (
                        <tr>
                          <td colSpan="2"></td>
                          <td
                            colSpan={4}
                           className="text-end font-12  mb-0 pb-0"
                          >
                         <span><b>₹{globalData.cardPaid}</b> Paid via Card</span>
                          </td>
                        </tr>
                      )}
                     {globalData?.onlinePaid > 0 && (
                        
                        <tr>
                          <td colSpan="2"></td>
                          <td
                            colSpan={4}
                           className="text-end font-12  mb-0 pb-0"
                          >
                        <span><b>₹{globalData.onlinePaid}</b> Paid via Online</span>
                          </td>
                        </tr>
                      )}
                    </tbody> 

                  </table>
         <div className="row mt-4 align-items-start">
       
                                     {/* 🔹 LEFT: QR Code */}
                                     <div className="col-1 px-0 ps-2 d-flex flex-column">
                                       <span className ="px-2 fw-bold pb-0">Pay Using UPI</span>
                                       {storeSettings?.paymentSettings?.upiId && (
                                         <img
                                           src={qrCodeDataUrl}
                                           alt="QR Code"
                                           style={{ width: "90px", height: "90px" }}
                                         />
                                       )}
                                     </div>
       
                                     {/* 🔹 CENTER: Bank Details */}
                                     <div className="col-7 px-0 ps-2">
                                       <div className="font-12">
                                         <strong>Bank Details:</strong>
       
                                         <div className="d-flex">
                                           <span style={{ width: "85px" }}>Name:</span>
                                           <strong>
                                             {storeSettings?.paymentSettings?.bankDetails?.beneficiaryName || ""}
                                           </strong>
                                         </div>
       
                                         <div className="d-flex">
                                           <span style={{ width: "85px" }}>Account #:</span>
                                           <strong>
                                             {storeSettings?.paymentSettings?.bankDetails?.accountNo || ""}
                                           </strong>
                                         </div>
       
                                         <div className="d-flex">
                                           <span style={{ width: "85px" }}>IFSC:</span>
                                           <strong>
                                             {storeSettings?.paymentSettings?.bankDetails?.ifsc || ""}
                                           </strong>
                                         </div>
       
                                         <div className="d-flex">
                                           <span style={{ width: "85px" }}>UPI ID:</span>
                                           <strong>
                                             {storeSettings?.paymentSettings?.upiId || ""}
                                           </strong>
                                         </div>
                                       </div>
                                     </div>
       
                                     {/* 🔹 RIGHT: Signature */}
                                     <div className="col-4 text-end">
                                       {storeSettings?.invoiceSettings?.signature && (
                                         <img
                                           src={
                                             uRLs.IMAGE_URL +
                                             storeSettings?.invoiceSettings?.signature
                                           }
                                           alt="Signature"
                                           style={{ width: "120px", marginBottom: "5px" }}
                                         />
                                       )}
       
                                       <div style={{ fontSize: "12px" }}>
                                         Issued By, Signature
                                       </div>
                                     </div>
       
                                   </div>
                  {terms?.length > 0 && (
                    <table width="100%" className="mt-2">
                      <tbody>
                       
                        <tr>
                          <td
                            style={{
                              padding: "8px",
                            }}
                            width="100%"
                          >
                            <div
                              className="fs-13 fw-600"
                              style={{
                                textAlign: "left",
                                color: "black",
                              }}
                            >
                              Terms & Conditions
                            </div>
                            <div className="terms-box">{terms}</div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  )}
                </div>
              </div>
            </div>
          </div>
        ) : data.salemode === "BILL" ? (
          <div className="tm_container">
            <div className="tm_invoice_wrap">
              <div className="tm_invoice tm_style1 tm_type1">
                
              </div>
            </div>
          </div>
        ) : (
          <div className="default-content">
            <p>No content available for this sale mode.</p>
          </div>
        )}
      </div>

      <div
        className="modal-footer d-block mt-2"
        style={{
          position: "sticky",
          bottom: -4,
          background: "#fff",
          zIndex: 10,
          borderTop: "1px solid #e0e0e0",
        }}
      >
        {payment && <div className="fw-600 mb-2 font-14">PAYMENT SUMMARY</div>}
        {payment && (
          <table
            className="items table-bordered mb-3"
            width="100%"
            cellPadding="4"
          >
            <tbody className="text-center">
              <tr>
                <th
                  style={{
                    textAlign: "center",
                    background: "#f3f3f3",
                    border: "0.5mm solid #e0e0e0",
                    cursor: isViewData.cashamount > 0 ? "pointer" : "default",
                    padding: "2px 8px",
                  }}
                  onClick={(e) => {
                    if (isViewData.cashamount > 0) {
                      cashRef.current.openPopover(e);
                    }
                  }}
                >
                  <div
                    className={
                      isViewData?.cashamount > 0
                        ? "badge rounded-pill bg-label-moon d-inline-flex align-items-center"
                        : "d-inline-flex align-items-center"
                    }
                    style={{ gap: "4px", fontSize: "12px" }}
                  >
                    CASH
                    {isViewData?.cashamount > 0 && <ShowIcon/>}
                  </div>
                </th>
                <th
                  style={{
                    textAlign: "center",
                    background: "#f3f3f3",
                    border: "0.5mm solid #e0e0e0",
                    fontSize: "12px",
                  }}
                >
                  CARD
                </th>
                <th
                  style={{
                    textAlign: "center",
                    background: "#f3f3f3",
                    border: "0.5mm solid #e0e0e0",
                    fontSize: "12px",
                  }}
                >
                  ONLINE
                </th>
                <th
                  style={{
                    textAlign: "center",
                    background: "#f3f3f3",
                    border: "0.5mm solid #e0e0e0",
                    fontSize: "12px",
                  }}
                >
                  UPI
                </th>
                <th
                  style={{
                    textAlign: "center",
                    background: "#f3f3f3",
                    border: "0.5mm solid #e0e0e0",
                    cursor:
                      isViewData?.paylateramount > 0 ? "pointer" : "default",
                    padding: "2px 8px",
                    fontSize: "12px",
                  }}
                  onClick={(e) => {
                    if (isViewData?.paylateramount > 0) {
                      paylaterRef.current.openPopover(e);
                    }
                  }}
                >
                  <div
                    className={
                      isViewData?.paylateramount > 0
                        ? "badge rounded-pill bg-label-fire d-inline-flex align-items-center"
                        : "d-inline-flex align-items-center"
                    }
                    style={{ gap: "4px" }}
                  >
                    PAYLATER
                    {isViewData?.paylateramount > 0 && (
                      <ShowIcon iClass={"ms-1"} />
                    )}
                  </div>
                </th>
              </tr>
              <tr>
                <td
                  style={{
                    textAlign: "center",
                    border: "0.5mm solid #e0e0e0",
                    fontSize: "12px",
                  }}
                  className="text-center"
                >
                  {formatCurrency2(
                    (isViewData?.cashamount || 0) -
                      (isViewData?.cashchange || 0)
                  )}
                </td>
                <td
                  style={{
                    textAlign: "center",
                    border: "0.5mm solid #e0e0e0",
                    fontSize: "12px",
                  }}
                  className="text-center"
                >
                  {formatCurrency2(
                    (isViewData?.cardamount || 0) -
                      (isViewData?.cardchange || 0)
                  )}
                </td>
                <td
                  style={{
                    textAlign: "center",
                    border: "0.5mm solid #e0e0e0",
                    fontSize: "12px",
                  }}
                  className="text-center"
                >
                  {formatCurrency2(
                    (isViewData?.onlineamount || 0) -
                      (isViewData?.onlinechange || 0)
                  )}
                </td>
                <td
                  style={{
                    textAlign: "center",
                    border: "0.5mm solid #e0e0e0",
                    fontSize: "12px",
                  }}
                  className="text-center"
                >
                  {formatCurrency2(
                    (isViewData?.upiamount || 0) - (isViewData?.upichange || 0)
                  )}
                </td>
                <td
                  style={{
                    textAlign: "center",
                    border: "0.5mm solid #e0e0e0",
                    fontSize: "12px",
                  }}
                  className="text-center"
                >
                  {formatCurrency2(
                    (isViewData?.paylateramount || 0) -
                      (isViewData?.paylaterchange || 0)
                  )}
                </td>
              </tr>
            </tbody>
            <CashButton
              ref={cashRef}
              trackId={isViewData?.boxCashInfo?.trackid}
              trackMode={isViewData?.boxCashInfo?.trackmode}
            />
            <PayLaterButton
              ref={paylaterRef}
              trackId={isViewData?.paylaterInfo?.trackid}
              customerId={isViewData?.paylaterInfo?.customerid}
              trackMode={isViewData?.paylaterInfo?.trackmode}
            />
          </table>
        )}
        {downloadbtn && (
          <div className="my-2 d-flex gap-2">
            <div className="btn-group text-right align-items-center">
              {print ? (
                <button
                  className="btn bg-label-animal btn-sm pb-0 font-12"
                  disabled
                >
                  <CircularProgress size={12} className="text-white" />
                </button>
              ) : (
                <>
                  <button
                    onClick={() => handlePrint(data)}
                    className="btn bg-label-animal shadow-none btn-sm font-12"
                    id="printreceiptbtn"
                  >
                    <PrinterIcon iClass={"fs-12"}/> Print
                  </button>
                </>
              )}
            </div>

            {download ? (
              <button
                className="btn btn-warning btn-sm pb-0 text-right"
                disabled
              >
                <CircularProgress size={18} className="text-black" />
              </button>
            ) : (
              <button
                className="btn btn-warning btn-sm text-right"
                id="generatebillpdfbtn"
                onClick={() => handleDownload(data)}
              >
                <DownloadIcon iClass={"fs-15"}/>
              </button>
            )}
          </div>
        )}
      </div>
    </>
  );
};

export default InvoiceThumnail5;
